import * as THREE from "three";

/**
 * A small floating indicator shown above Binary Search's current mid box
 * (Master Spec §23) so the player knows where to walk next — the pivot
 * is engine-computed, not wherever the player happens to be standing,
 * which is what makes Binary Search feel different from Linear Search
 * (Master Spec §23's explicit requirement).
 */
export interface MidMarkerHandles {
  mesh: THREE.Mesh;
  setVisible: (visible: boolean) => void;
  dispose: () => void;
}

const MARKER_COLOR = 0x38bdf8;
const MARKER_EMISSIVE = 0x0b3a52;

export function createMidMarker(): MidMarkerHandles {
  const geometry = new THREE.ConeGeometry(0.18, 0.32, 4);
  const material = new THREE.MeshStandardMaterial({
    color: MARKER_COLOR,
    roughness: 0.3,
    emissive: MARKER_EMISSIVE,
    emissiveIntensity: 0.6,
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.rotation.x = Math.PI;
  mesh.visible = false;

  function setVisible(visible: boolean): void {
    mesh.visible = visible;
  }

  function dispose(): void {
    geometry.dispose();
    material.dispose();
  }

  return { mesh, setVisible, dispose };
}
